import {
  generateMockMedicalTreatmentAppointmentPayload,
  generateMockMedicalTreatmentBillPayload,
  generateMockMedicalTreatmentPayload,
  generateMockMedicalTreatmentRecordPayload,
} from "@/lib/data/factories/matter-subitem-payload-factory";
import {
  useCreateMedicalTreatment,
  useCreateMedicalTreatmentAppointment,
  useCreateMedicalTreatmentBill,
} from "@/lib/data/react-query";
import { useCreateMedicalTreatmentRecord } from "@/lib/data/react-query/matters/medical-treatment-record";
import { useCallback } from "react";
import { createMultiple } from "./mock-api-utils";

export const useCreateMockMedicalTreatmentSubitems = () => {
  const createMedicalTreatment = useCreateMedicalTreatment();
  const createMedicalTreatmentAppointment =
    useCreateMedicalTreatmentAppointment({});
  const createMedicalTreatmentRecord = useCreateMedicalTreatmentRecord({});
  const createMedicalTreatmentBill = useCreateMedicalTreatmentBill({});

  const createMockMedicalTreatment = useCallback(
    async (
      matterId: string,
      count = 1,
      overrides: Record<string, unknown> = {},
    ) =>
      createMultiple(count, () =>
        createMedicalTreatment.mutateAsync(
          generateMockMedicalTreatmentPayload(matterId, overrides),
        ),
      ),
    [createMedicalTreatment],
  );

  const createMockMedicalTreatmentAppointment = useCallback(
    async (
      medicalTreatmentId: string,
      matterId: string,
      count = 1,
      overrides: Record<string, unknown> = {},
    ) =>
      createMultiple(count, () =>
        createMedicalTreatmentAppointment.mutateAsync(
          generateMockMedicalTreatmentAppointmentPayload(
            medicalTreatmentId,
            matterId,
            overrides,
          ),
        ),
      ),
    [createMedicalTreatmentAppointment],
  );

  const createMockMedicalTreatmentRecord = useCallback(
    async (
      matterId: string,
      medicalTreatmentId: string,
      count = 1,
      overrides: Record<string, unknown> = {},
    ) =>
      createMultiple(count, () =>
        createMedicalTreatmentRecord.mutateAsync(
          generateMockMedicalTreatmentRecordPayload(
            matterId,
            medicalTreatmentId,
            overrides,
          ),
        ),
      ),
    [createMedicalTreatmentRecord],
  );

  const createMockMedicalTreatmentBill = useCallback(
    async (
      matterId: string,
      medicalTreatmentId: string,
      count = 1,
      overrides: Record<string, unknown> = {},
    ) =>
      createMultiple(count, () =>
        createMedicalTreatmentBill.mutateAsync(
          generateMockMedicalTreatmentBillPayload(
            matterId,
            medicalTreatmentId,
            overrides,
          ),
        ),
      ),
    [createMedicalTreatmentBill],
  );

  return {
    createMockMedicalTreatment,
    createMockMedicalTreatmentAppointment,
    createMockMedicalTreatmentRecord,
    createMockMedicalTreatmentBill,
    mutations: {
      medicalTreatment: createMedicalTreatment,
      appointment: createMedicalTreatmentAppointment,
      record: createMedicalTreatmentRecord,
      bill: createMedicalTreatmentBill,
    },
  };
};
